"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarKeyEventUtility = void 0;
class CalendarKeyEventUtility {
    static preventDefaultActions(keyEvent) {
        if (!keyEvent) {
            return;
        }
        // Suppress "double action" if event handled
        keyEvent.preventDefault();
        keyEvent.stopPropagation();
    }
    static getKeyEventName(event) {
        if (!event) {
            return CalendarKeyEventUtility.KEY_EVENT_NAMES.UNKNOWN;
        }
        this.preventDefaultActions(event);
        const keyCode = event.keyCode || event.which;
        if (CalendarKeyEventUtility.EVENT_NAMES_TO_CODE_MAP[keyCode]) {
            return CalendarKeyEventUtility.EVENT_NAMES_TO_CODE_MAP[keyCode].name;
        }
        return CalendarKeyEventUtility.KEY_EVENT_NAMES.UNKNOWN;
    }
}
exports.CalendarKeyEventUtility = CalendarKeyEventUtility;
CalendarKeyEventUtility.KEY_EVENT_NAMES = {
    'ENTER': 'ENTER',
    'ESCAPE': 'ESCAPE',
    'SPACE': 'SPACE',
    'LEFT_ARROW': 'LEFT_ARROW',
    'UP_ARROW': 'UP_ARROW',
    'RIGHT_ARROW': 'RIGHT_ARROW',
    'DOWN_ARROW': 'DOWN_ARROW',
    'UNKNOWN': 'UNKNOWN'
};
CalendarKeyEventUtility.EVENT_NAMES_TO_CODE_MAP = {
    '13': { 'name': CalendarKeyEventUtility.KEY_EVENT_NAMES.ENTER },
    '27': { 'name': CalendarKeyEventUtility.KEY_EVENT_NAMES.ESCAPE },
    '32': { 'name': CalendarKeyEventUtility.KEY_EVENT_NAMES.SPACE },
    '37': { 'name': CalendarKeyEventUtility.KEY_EVENT_NAMES.LEFT_ARROW },
    '38': { 'name': CalendarKeyEventUtility.KEY_EVENT_NAMES.UP_ARROW },
    '39': { 'name': CalendarKeyEventUtility.KEY_EVENT_NAMES.RIGHT_ARROW },
    '40': { 'name': CalendarKeyEventUtility.KEY_EVENT_NAMES.DOWN_ARROW }
};
